import { z } from "zod"

import { PasswordSchema } from "@/lib/set-password-form"
import { shouldTurnstile } from "@/lib/turnstile"

export const RegistrationFormSchema = z
  .object({
    email: z.email(),
    password: PasswordSchema,
    cf_token: z.string(),
    cf_token_required: z.boolean(),
    organization_email_opt_in: z.boolean(),
  })
  .superRefine((val, ctx) => {
    if (val.cf_token_required && !val.cf_token) {
      ctx.addIssue({
        path: ["cf_token"],
        code: "custom",
        message: "Cf token is required",
      })
    }
  })

export type RegistrationFormValue = z.infer<typeof RegistrationFormSchema>

export type RegistrationFormErrors = z.core.$ZodFormattedError<
  z.output<typeof RegistrationFormSchema>
>

export type RegistrationFormValidated = z.infer<typeof RegistrationFormSchema>

export function validateRegistrationFormValue(
  value: RegistrationFormValue
):
  | [true, RegistrationFormValidated, null]
  | [false, null, RegistrationFormErrors] {
  const res = RegistrationFormSchema.safeParse(value)

  if (res.success) {
    return [true, res.data, null]
  }

  return [false, null, z.formatError(res.error)]
}

export function emptyRegistrationFormState(email?: string) {
  const value = {
    email: email ?? "",
    password: "",
    cf_token: "",
    cf_token_required: shouldTurnstile("register"),
    organization_email_opt_in: false,
  }
  const [_, validated, errors] = validateRegistrationFormValue(value)
  return [value, validated, errors]
}
